import auVariables from "@skv/frontend/src/styles/au-variables.scss";
import baseTheme from "@skv/frontend/src/styles/jsvariables.scss";

import { timingFunctions } from "polished";

export const auTheme = Object.assign({}, baseTheme, auVariables, {
  timingFnEaseOut: timingFunctions("easeOutCubic"),
});
